const PROJECT_STORAGE_KEY = "anna_project_id";

/** Current project for list and SIP requests. Absent until the switcher sets one. */
export function getApiProjectId(): number | null {
  try {
    const raw = localStorage.getItem(PROJECT_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const id = Number(raw);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function setApiProjectId(id: number | null): void {
  try {
    if (id == null) {
      localStorage.removeItem(PROJECT_STORAGE_KEY);
    } else {
      localStorage.setItem(PROJECT_STORAGE_KEY, String(id));
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function withProjectParams<T extends Record<string, unknown>>(
  params: T,
): T & { project?: number } {
  const id = getApiProjectId();
  if (id == null) {
    return params;
  }
  return { ...params, project: id };
}
